import { Checkmark } from '@benzinga/themed-icons';

export const OptionButton = ({ index, label, selectedVal, setMethod, value }) => {
  const letter = String.fromCharCode(65 + index);
  const selected = Array.isArray(selectedVal) ? selectedVal.includes(value) : selectedVal === value;
  return (
    <div className="flex items-center">
      <button
        className={`max-w-xs border border-bzblue-800 p-2 rounded-md flex items-center ${
          selected ? 'bg-bzblue-800 text-white' : 'bg-bzblue-400/50 text-bzblue-800'
        }`}
        onClick={() => setMethod(value)}
      >
        <div className="border border-bzblue-800 text-bzblue-800 p-1 mr-2 rounded-md text-xs bg-white w-6 h-6">
          {letter}
        </div>
        <span className="text-left">{label}</span>
      </button>
      {selected && <Checkmark className="ml-2 fill-green-600 text-lg" />}
    </div>
  );
};
